import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core'
import { AuthService } from '../../core/services/auth.service'
import { SnackbarService } from '../../core/services/snackbar.service'

@Directive({
    selector: '[submitButton]',
    standalone: false
})
export class SubmitButtonDirective {
    constructor(
        private auth: AuthService,
        private snackbar: SnackbarService
    ) {}

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        if (!this.auth.isAdmin()) {
          event.preventDefault()
          event.stopPropagation()
          this.snackbar.showSnackbar("You're not allowed!")
        }
    }
}